/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetEquipmentBrowserConfigRequest = {
  agentId: string;
};

/** @internal */
export const GetEquipmentBrowserConfigRequest$inboundSchema: z.ZodType<
  GetEquipmentBrowserConfigRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type GetEquipmentBrowserConfigRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const GetEquipmentBrowserConfigRequest$outboundSchema: z.ZodType<
  GetEquipmentBrowserConfigRequest$Outbound,
  z.ZodTypeDef,
  GetEquipmentBrowserConfigRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getEquipmentBrowserConfigRequestToJSON(
  getEquipmentBrowserConfigRequest: GetEquipmentBrowserConfigRequest,
): string {
  return JSON.stringify(
    GetEquipmentBrowserConfigRequest$outboundSchema.parse(
      getEquipmentBrowserConfigRequest,
    ),
  );
}
export function getEquipmentBrowserConfigRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetEquipmentBrowserConfigRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetEquipmentBrowserConfigRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetEquipmentBrowserConfigRequest' from JSON`,
  );
}
